import { createSelector } from '@reduxjs/toolkit';

import { IPolygon } from 'shared/map-search/types/map/polygon';

import { selectPolygons } from './selectPolygons';

export const selectInvertedPolygons = createSelector(selectPolygons, polygons =>
  polygons.map<IPolygon>(polygon => ({
    ...polygon,
    coordinates: polygon.coordinates.map(([a, b]) => [b, a] as [number, number]),
  })),
);
